export const DAYS = [7, 15, 30, 60, 90, 180, 365]

export const SCENE = [
  {
    key: 'E-COMMERCE',
    label: '电商互动行为'
  }, {
    key: 'NEWS',
    label: '资讯互动行为'
  }, {
    key: 'APP',
    label: 'App推广互动行为'
  }
]
